import React from 'react';
import {TXHR} from '../../../../assets/constants/constansts.type';
import * as css from './WhatsAppEditorFooter.css';
import WhatsAppEditorFooterToolbar from './whatsAppEditorFooterToolbar/WhatsAppEditorFooterToolbar';
import WhatsAppEditorFooterActions from './whatsAppEditorFooterActions/WhatsAppEditorFooterActions';

interface WhatsAppEditorFooterProps {
    hasChanged: boolean;
    totalCharacters: number;
    isCharCountExceeded: boolean;
    onFormat?: (command: string) => void;
    onClearAll: () => void;
    clearAllLabel: string;
    segmentedValue: string;
    onModeSwitch: (mode: string) => void;
    save: {
        onSave?: () => void;
        disabled?: boolean;
        xhr?: TXHR;
        text?: string;
    };
}

function WhatsAppEditorFooter({
    hasChanged,
    totalCharacters,
    isCharCountExceeded,
    onFormat,
    onClearAll,
    clearAllLabel,
    segmentedValue,
    onModeSwitch,
    save
}: WhatsAppEditorFooterProps) {
    return (
        <css.footer data-cy="whatsapp-editor-footer">
            <WhatsAppEditorFooterToolbar
                onFormat={onFormat}
                totalCharacters={totalCharacters}
                isCharCountExceeded={isCharCountExceeded}
                onClearAll={onClearAll}
                clearAllLabel={clearAllLabel}
            />
            {save.onSave && <css.divider />}
            {save.onSave && <WhatsAppEditorFooterActions
                segmentedValue={segmentedValue}
                onModeSwitch={onModeSwitch}
                hasChanged={hasChanged}
                save={save}
            />}
        </css.footer>
    );
}

export default WhatsAppEditorFooter;
